import _ from "lodash";

export function transformSlug(slug) {
  return _.kebabCase(slug);
}

export function firstCharUpperCase(title) {
  return _.upperFirst(_.toLower(title));
}
